/* eslint-disable import/prefer-default-export */
export * as Global from './Global.styles';

export const CLASS_MAP = {
  LAYOUT_CONTAINER: 'layout-container',
  LAYOUT_CONTAINER_CONTENT: 'layout-container-content',
  LAYOUT_CONTENT_ONLY_PADDING: 'layout-content-only-padding',
  LAYOUT_CONTENT_ONLY_MARGIN: 'layout-content-only-margin',
} as const;
